module.exports = __webpack_public_path__ + "img/transaction.7b3765ee.png";